import React, { useEffect, useState } from "react";
import { ViewForms } from "./view-forms";
import { PulseLoader } from "react-spinners";
import PropTypes from "prop-types";
import { FormAutomationGrid } from "../grid/form-automation-grid";
import { GetDynamicFormsForAdminPage } from "../../../../../../../services/api/task-form-api";
import FluentUiIcon from "../../../../../../../assets/fluent-ui-icon";

export const FormAutomation = ({ taskTypeId, formDataFromParent }) => {
  const taskTypeIdToInt = parseInt(taskTypeId);
  const [formId, setFormId] = useState(null);
  const [formName, setFormName] = useState("");
  const [allForms, setAllForms] = useState({
    data: [],
    isLoading: true,
  });

  useEffect(() => {
    const LoadForms = async () => {
      try {
        if (formDataFromParent?.data) {
          setAllForms((prev) => ({
            ...prev,
            data: formDataFromParent.data,
            isLoading: false,
          }));
        } else {
          let result = [];
          if (taskTypeIdToInt > 0) {
            result = await GetDynamicFormsForAdminPage(taskTypeIdToInt);
          }
          setAllForms((prev) => ({
            ...prev,
            data: result.data,
            isLoading: false,
          }));
        }
      } catch (e) {
        console.log("Error [GetDynamicFormForAdminPage] => ", e);
      }
    };
    LoadForms();
  }, []);

  return (
    <div className="form-design">
      {formId ? (
        <>
          <div className="mt-2 top-actions">
            <div
              className="back-button"
              onClick={() => {
                setFormId(null);
              }}
            >
              <FluentUiIcon
                name={"ArrowLeftRegular"}
                color={"#0e75bb"}
                size={20}
              />
              <span>Back to Forms</span>
            </div>
          </div>
          <div className="mt-2 top-actions">
            <div className="title text-left mt-2 mb-2">{formName}</div>
          </div>
          <FormAutomationGrid
            formId={formId}
            setFormId={setFormId}
            formName={formName}
            type={"form-visibility"}
            name={"Form Visibility"}
          />
          <div className="mt-5"></div>
          <FormAutomationGrid
            formId={formId}
            setFormId={setFormId}
            formName={formName}
            type={"field-visibility"}
            name={"Field Visibility"}
          />
          <div className="mt-5"></div>
          <FormAutomationGrid
            formId={formId}
            setFormId={setFormId}
            formName={formName}
            type={"table"}
            name={"Table Customizations"}
          />
        </>
      ) : allForms.isLoading ? (
        <div className="pulse-loader" data-testid="loading-spinner">
          <PulseLoader></PulseLoader>
        </div>
      ) : (
        <ViewForms
          setFormId={setFormId}
          setFormName={setFormName}
          allForms={allForms}
        />
      )}
    </div>
  );
};

FormAutomation.propTypes = {
  taskTypeId: PropTypes.string,
  formDataFromParent: PropTypes.shape({
    data: PropTypes.array,
  }),
};
